export enum KeyCodes {
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  ArrowUp = 'ArrowUp',
  ArrowDown = 'ArrowDown',
  Home = 'Home',
  End = 'End',
  Enter = 'Enter',
  Escape = 'Escape',
  Up = 'Up',
  Down = 'Down',
  Left = 'Left',
  Right = 'Right',
  Space = ' ',
}
